export const getWidthFromTextSize = (
  textSize?: 'Small' | 'Medium' | 'Large'
): React.CSSProperties['width'] => {
  switch (textSize) {
    case 'Small':
      return '30%';

    case 'Medium':
      return '60%';

    case 'Large':
      return '100%';

    default:
      return undefined;
  }
};
